module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "ctfm"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_IX",
      "title": "IX"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("LIST OF FIGURES AND TABLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#fig1_1"
    }
  }, [_vm._v("Figure 1.1")]), _vm._v(": Attitudes toward Homosexuality in Western Europe and Postcommunist Europe Compared (circa 2000)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#fig1_2"
    }
  }, [_vm._v("Figure 1.2")]), _vm._v(": Rights of Gays, Lesbians, and Bisexuals in Western and Eastern Europe Compared (2010)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#fig1_3"
    }
  }, [_vm._v("Figure 1.3")]), _vm._v(": Social Attitudes (circa 2000) vs. LGBT Rights (2010) in Western and Eastern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#fig1_4"
    }
  }, [_vm._v("Figure 1.4")]), _vm._v(": The Interaction of EU Leverage and the Domestic Determinants of LGBT Movement Mobilization")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#fig1_5"
    }
  }, [_vm._v("Figure 1.5")]), _vm._v(": Situating the Country Cases by Societal Openness (circa 2000)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#tab2_1"
    }
  }, [_vm._v("Table 2.1")]), _vm._v(": Comparison of Subgroup Means by Proximity to the EU")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#tab2_2"
    }
  }, [_vm._v("Table 2.2")]), _vm._v(": The Transnational and Domestic Determinants of Legal Rights Frameworks for Gays, Lesbians, and Bisexuals in Europe (2009–2013)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#fig3_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.1")]), _vm._v(": Hard-Right Seat Share in National Parliamentary Elections (Poland and the Czech Republic)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#fig3_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.2")]), _vm._v(": A Comparison of the Incidence of Articles Containing the Term “Homosexual” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Gazeta Wyborcza")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Mladá fronta dnes")]), _vm._v(" (1990–2012)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#fig3_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.3")]), _vm._v(": A Comparison of the Incidence of Articles Containing the Term “Homophobia” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Gazeta Wyborcza")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Mladá fronta dnes")]), _vm._v(" (1990–2012)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#fig4_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.1")]), _vm._v(": SOHO’s Financial Resources in Nominal Czech Crowns (Kč)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_x",
      "title": "x"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#fig6_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6.1")]), _vm._v(": Estimated Number of Participants at Warsaw Equality Marches (2001–2012)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#tab6_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 6.1")]), _vm._v(": Exit Polling among TR Voters in Poland’s 2011 Parliamentary Elections")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#tab6_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 6.2")]), _vm._v(": Poland’s 2011 Parliamentary Election Results by Party")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#fig6_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6.2")]), _vm._v(": Number of Czech LGBT Groups by Primary Orientation (1988–2012)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#fig6_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6.3")]), _vm._v(": Number of Polish LGBT Groups by Primary Orientation (1990–2012)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#fig7_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.1")]), _vm._v(": Hard-Right Seat Share in National Parliamentary Elections (Hungary, Romania, and Slovakia)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#fig7_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.2")]), _vm._v(": Attendance at Pride Parades in Budapest, Bucharest, and Bratislava (1997–2015)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#fig7_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.3")]), _vm._v(": Number of Hungarian LGBT Groups by Primary Orientation (1985–2012)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#fig7_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.4")]), _vm._v(": Number of Slovak LGBT Groups by Primary Orientation (1988–2012)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#fig7_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.5")]), _vm._v(": Number of Romanian LGBT Groups by Primary Orientation (1990–2012)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#figC_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure C.1")]), _vm._v(": Attitudes toward Homosexuality by Region (1981–2014) [Survey question: “Homosexuality is always (10)/never (0) justified.”]")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#tabC_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table C.1")]), _vm._v(": Percentage of Czechs/Poles Saying That Homosexuality Should Be Accepted")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix#tabA_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table A.1")]), _vm._v(": Descriptive Statistics and Correlations")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix#tabA_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table A.2")]), _vm._v(": Hard-Right Parties by Country")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix#tabA_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table A.3")]), _vm._v(": Social-Movement Groups by Country")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f744a2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illustration.vue
// module id = 72
// module chunks = 0